module.exports = __webpack_public_path__ + "img/noWish.559f2e71.png";